@let isExportWizardOpen = routeStore.isExportWizardOpen();
@let showAsset = routeStore.showAsset();
@let isNestedViewState = routeStore.isNestedViewState();
@let isAssetOpen = routeStore.isAssetOpen();
@let assetNodeId = routeStore.assetNodeId();
@let assetId = routeStore.assetId();
@let assetSapId = routeStore.assetSapId();
@let isExportRoute = routeStore.isExportRoute();
@let selectedSapAsset = routeStore.selectedSapAsset();
@let isRegularMachinesZone = routeStore.isRegularMachinesZone();

<sma-web-navigation />
<sma-web-modal #accountExpiry>
  <div class="app-modal-header">
    <h3>{{ 'EXPIRY.TITLE' | translate }}</h3>
  </div>
  <div class="app-modal-body">
    @if (appName()) {
      <p
        class="fwe-m-0"
        [innerHTML]="'EXPIRY.DESCRIPTION' | translate : { value: daysToDeleteAccount(), appName: appName() } | customSanitizeHtml"
      ></p>
    }
  </div>
  <div class="app-modal-footer">
    <fng-button [primary]="true" smaWebPrimaryButton (fngClick)="accountExpiry.hide()">
      {{ 'EXPIRY.BUTTON' | translate }}
    </fng-button>
  </div>
</sma-web-modal>
<sma-web-feedback [hideFeedback]="isExportWizardOpen" [contactMailAddress]="contactMailAddress()" [appName]="appName()" />
<sma-web-alerts [alerts]="alerts()" (dismissed)="dismissAlert($event)" />
<div class="scroll-body-container">
  <div [class]="isAssetTreeNextTo() ? 'next-to-mode' : 'cover-mode'" class="asset-body">
    <sma-web-asset-layout
      [showAsset]="showAsset"
      [isAssetOpen]="isAssetOpen"
      [showExportMenu]="isExportRoute"
      [isNestedViewState]="isNestedViewState"
      [assetNodeId]="assetNodeId"
      [assetMachineId]="assetId"
      [assetSapMachineId]="assetSapId"
      [sapSelected]="selectedSapAsset"
      [isRegularMachineZone]="isRegularMachinesZone"
    />
  </div>
  <div class="scroll-body">
    <ng-content select=".page-header-block" />
    <router-outlet />
    <sma-web-footer
      [dataprivacyUrl]="dataprivacyUrl()"
      [imprintUrl]="imprintUrl()"
      (versionIntroClicked)="navigateOnReleaseInformation()"
    />
  </div>
</div>
<sma-web-right-content-view-overlay />
<fng-snackbar-container />
